"use client";

import { c as _c } from "react/compiler-runtime";
import { useFormContext, useWatch } from "react-hook-form";
import type { BusinessUnitsSchemaType } from "@/components/modules/portfolio/api/schemas/schemas";
export function useAssociateUnitStep(currentUnitId) {
  const $ = _c(8);
  const {
    setValue,
    control
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "selectedUnitId"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectedUnitId = useWatch(t0);
  let t1;
  if ($[2] !== currentUnitId || $[3] !== setValue) {
    t1 = unit => {
      if (currentUnitId && unit.id === currentUnitId) {
        return;
      }
      setValue("selectedUnitId", unit.id, {
        shouldDirty: true,
        shouldValidate: true
      });
      setValue("selectedUnitTitle", unit.title, {
        shouldDirty: true
      });
    };
    $[2] = currentUnitId;
    $[3] = setValue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleSelectUnit = t1;
  let t2;
  if ($[5] !== handleSelectUnit || $[6] !== selectedUnitId) {
    t2 = {
      selectedUnitId,
      handleSelectUnit
    };
    $[5] = handleSelectUnit;
    $[6] = selectedUnitId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}